import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKFuji = () => (
  <ArticleWrapper articleId="gmk_fuji">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Fuji</h1>
        {/* Add your GMK Fuji article content here */}
        <p>This is a placeholder article for the GMK Fuji keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKFuji;
